var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-8",attrs:{"fluid":""}},[_vm._v(" Access Denied ")])
}
var staticRenderFns = []

export { render, staticRenderFns }